import { AbstractIconComponent } from '../abstract.icon'
import { Component } from '@angular/core'

@Component({
  selector: 'icon-ev-connector-chademo',
  templateUrl: './ev-connector-chademo.icon.html',
})
export class EvConnectorChaDemoIconComponent extends AbstractIconComponent {
  static icon = 'ev-connector-chademo'
}
